import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCaretDown, faCaretUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { WatchlistService } from 'src/app/services/watchlist.service';

@Component({
  selector: 'app-watchlist',
  templateUrl: './watchlist.component.html',
  styleUrls: ['./watchlist.component.css']
})
export class WatchlistComponent implements OnInit {
  watchlistSpinnerDisplay = "inline";

  faClose = faTimes;
  faCaretUp = faCaretUp;
  faCaretDown = faCaretDown;
  stockValueChange = 0;
  stockValueChangePercent = 0;
  caretVisibility = "visible";
  nothingInWatchlistAlertDisplay: string = "inline";
  watchlistDataToRender;

  constructor(private watchlistService: WatchlistService, private router: Router) { }

  loadWatchlistItems() {
    let watchlist: any = localStorage.getItem("ritesht_watchlist_stocks");
    if (watchlist !== null && watchlist !== undefined) {
      watchlist = JSON.parse(watchlist);
      Object.keys(watchlist).forEach(key => {
        if (!watchlist[key]) delete watchlist[key];
      });

      if (watchlist === undefined || watchlist === null)
        watchlist = {};

      if (Object.keys(watchlist).length > 0) {
        this.nothingInWatchlistAlertDisplay = "none";

        this.watchlistService.getWatchlistData(Object.keys(watchlist).join(",")).subscribe(watchlistData => {
          let temp: any = localStorage.getItem("ritesht_watchlist_stock_names");
          this.watchlistSpinnerDisplay = "none";
          this.watchlistDataToRender = watchlistData.map(r => {
            let o = {};
            if (temp === null)
              o["stockName"] = "NA";
            else {
              let t = JSON.parse(temp);
              if (t[r["ticker"]] === null || t[r["ticker"]] === undefined)
                o["stockName"] = "NA";
              else
                o["stockName"] = t[r["ticker"]];
            }
            return { ...r, ...o }
          }).sort((a, b) => (a.ticker > b.ticker ? 1 : -1));
          console.log(this.watchlistDataToRender);
        });
      } else {
        this.watchlistDataToRender = [];
        this.watchlistSpinnerDisplay = "none";
        this.nothingInWatchlistAlertDisplay = "inline";
      }
    } else {
      this.watchlistDataToRender = [];
      this.watchlistSpinnerDisplay = "none";
      this.nothingInWatchlistAlertDisplay = "inline";
    }
  }

  ngOnInit(): void {
    this.loadWatchlistItems();
  }

  closeButton(watchlistItem) {
    let t: any = localStorage.getItem("ritesht_watchlist_stocks");
    if (t !== null && t !== undefined)
      t = JSON.parse(t);
    t[watchlistItem["ticker"]] = false;
    localStorage.setItem("ritesht_watchlist_stocks", JSON.stringify(t));

    this.loadWatchlistItems();
  }

  cardClicked(watchlistDataItem) {
    this.router.navigate(['/details/' + watchlistDataItem["ticker"]]);
  }

}
